import type { ReactNode } from "react";

import { Info } from "@/components/icons";
import { cn } from "@/lib/utils";

/**
 * Quiet inline informational message — the UI kit has no Alert, and this
 * is deliberately more muted than one: supporting context, not a warning.
 */
export function InfoNote({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      role="status"
      className={cn(
        "flex items-start gap-3 rounded-md border bg-muted/50 px-4 py-3 text-sm text-muted-foreground",
        className,
      )}
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <div className="min-w-0">{children}</div>
    </div>
  );
}
